import React, { useEffect, useState } from "react";
import SectionHeader from "../common/SectionHeader";

export default function ExpansionTab() {
  const [rankingData, setRankingData] = useState([]);

  useEffect(() => {
    const savedRanking = localStorage.getItem("last_simulation_ranking");
    if (savedRanking) setRankingData(JSON.parse(savedRanking));
  }, []);

  return (
    <div style={{ flex: 1, backgroundColor: '#FFFFFF', overflowY: 'auto' }}>
      <div style={{ padding: '32px 24px', maxWidth: '1000px', margin: '0 auto', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
        <SectionHeader
          icon={
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
              <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
              <path d="M4 22h16"></path>
              <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
              <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
            </svg>
          }
          title="Lista jerárquica de la última simulación"
          subtitle="Ranking algorítmico del orden de elección de las propuestas de expansión basadas en impacto poblacional."
        />
        <div style={{ marginBottom: '24px' }}>
          <hr style={{ border: 'none', borderTop: '1px solid #E5E7EB', margin: '0' }} />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {rankingData.length === 0 ? (
            <div style={{ textAlign: 'center', color: '#9CA3AF', padding: '40px' }}>
              Aún no se han corrido simulaciones. Ve a la vista de Expansión para calcular rutas.
            </div>
          ) : (
            rankingData.map((ruta, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', background: 'white', borderRadius: '16px', padding: '20px', boxShadow: '0 4px 6px rgba(0,0,0,0.02)', border: '1px solid #E5E7EB', position: 'relative', overflow: 'hidden', transition: 'all 0.2s', cursor: 'pointer' }}
                onMouseOver={(e) => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 10px 15px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = '#3B82F6'; }}
                onMouseOut={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.02)'; e.currentTarget.style.borderColor = '#E5E7EB'; }}
              >
                <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '6px', background: '#3B82F6' }} />
                <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#EFF6FF', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: '24px', fontWeight: 900, color: '#3B82F6', marginRight: '24px', flexShrink: 0 }}>#{index + 1}</div>
                <div style={{ flex: 1, paddingRight: '20px' }}>
                  <h3 style={{ margin: '0', fontSize: '18px', color: '#1F2937', fontWeight: 700 }}>{ruta.winnerRouteName}</h3>
                </div>
                <div style={{ display: 'flex', gap: '20px', borderLeft: '1px dashed #E5E7EB', paddingLeft: '24px', minWidth: '220px' }}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: '11px', color: '#6B7280', textTransform: 'uppercase', fontWeight: 700, marginBottom: '4px' }}>Nuevos Usuarios</span>
                    <span style={{ fontSize: '20px', fontWeight: 800, color: '#1F2937' }}>+{ruta.addedPopulation}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: '11px', color: '#6B7280', textTransform: 'uppercase', fontWeight: 700, marginBottom: '4px' }}>Incremento de cobertura</span>
                    <span style={{ fontSize: '20px', fontWeight: 800, color: '#10B981' }}>+{ruta.coverageIncreasePercentage}%</span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}